import {useTranslation} from "react-i18next";

type DateProps = {
    value: Date,
    options?: Intl.DateTimeFormatOptions | undefined;
    datePreset?: "short" | "medium" | "long" | "full";
    timePreset?: "short" | "medium" | "long" | "full";
}

export const Date = ({value, options, datePreset, timePreset}: DateProps) => {
    const {i18n} = useTranslation();

    if (datePreset) {
        switch (datePreset) {
            case "short":
                options = {year: "numeric", month: "numeric", day: "numeric", ...options};
                break;
            case "medium":
                options = {year: "numeric", month: "2-digit", day: "2-digit", ...options};
                break;
            case "long":
                options = {year: "numeric", month: "long", day: "2-digit", ...options};
                break;
            case "full":
                options = {weekday: "long", year: "numeric", month: "long", day: "2-digit", ...options};
                break;
        }
    }

    if (timePreset) {
        switch (timePreset) {
            case "short":
                options = {hour: "numeric", minute: "numeric", ...options};
                break;
            case "medium":
                options = {hour: "numeric", minute: "numeric", second: "numeric", ...options};
                break;
            case "long":
                options = {hour: "numeric", minute: "numeric", second: "numeric", timeZoneName: "short", ...options};
                break;
            case "full":
                options = {hour: "numeric", minute: "numeric", second: "numeric", timeZoneName: "short", ...options};
                break;
        }
    }

    return (
        <>
            {new Intl.DateTimeFormat(i18n.language, options).format(value)}
        </>
    );
}
